import Plausible from 'plausible-tracker'

const isProduction = process.env.NODE_ENV === 'production'
const domain = process.env.NEXT_PUBLIC_PLAUSIBLE_DOMAIN || 'linevo.watch'

// Initialize Plausible
const plausible = Plausible({
  domain,
  trackLocalhost: false,
  apiHost: process.env.NEXT_PUBLIC_PLAUSIBLE_API_HOST
})

// Analytics functions
export const analytics = {
  // Page views are automatically tracked by Plausible

  // Track custom events
  trackEvent: (eventName: string, props?: Record<string, string | number>) => {
    if (isProduction) {
      plausible.trackEvent(eventName, { props })
    } else {
      console.log('Analytics Event:', eventName, props)
    }
  },

  // Track specific business events
  trackSignup: (source?: string) => {
    analytics.trackEvent('Signup', { source: source || 'unknown' })
  },

  trackDemo: (source?: string) => {
    analytics.trackEvent('Demo Request', { source: source || 'unknown' })
  },

  trackDownload: (resource: string) => {
    analytics.trackEvent('Download', { resource })
  },

  trackContact: (type: 'email' | 'phone' | 'form') => {
    analytics.trackEvent('Contact', { type })
  },

  // Track page section views for longer pages
  trackSectionView: (section: string, page: string) => {
    analytics.trackEvent('Section View', { section, page })
  }
}

// Cookie consent management
export const cookieConsent = {
  // Check if user has given consent
  hasConsent: (): boolean => {
    if (typeof window === 'undefined') return false
    return localStorage.getItem('analytics-consent') === 'true'
  },

  // Set consent
  setConsent: (consent: boolean) => {
    if (typeof window === 'undefined') return
    localStorage.setItem('analytics-consent', consent.toString())
    
    if (consent) {
      // Enable analytics
      plausible.enableAutoPageviews()
    }
  },

  // Remove consent
  removeConsent: () => {
    if (typeof window === 'undefined') return
    localStorage.removeItem('analytics-consent')
  }
}

// Initialize analytics based on consent
export const initializeAnalytics = () => {
  if (typeof window === 'undefined') return
  
  // Auto-enable in production if consent given or not required
  if (isProduction && cookieConsent.hasConsent()) {
    plausible.enableAutoPageviews()
  }
}
